module.exports = __webpack_public_path__ + "img/hero_1.b21ab2b4.jpg";